import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    isLoading: false,
    isTabBar: true,
    openId: '',
    isJSSdk: false,
    shareTitle: '',
    shareDesc: '',
    shareUrl: '',
    shareImg: ''
  },
  mutations: {
    isLoading: (state, status) => {
      state.isLoading = status
    },
    isJSSdk: (state, status) => {
      state.isJSSdk = status
    },
    shareTitle: (state, status) => {
      state.shareTitle = status
    },
    isTabBar: (state, status) => {
      state.isTabBar = status
    },

    SET_OPENID (state, value) {
      state.openId = value
      localStorage.setItem('openid', value)
    }
  },
  actions: {
    setOpenid ({commit}, value) {
      commit('SET_OPENID', value)
    }
  },
  getters: {
    GetOpenID: (state) => {
      let openid = localStorage.getItem('openid')
      if (openid) {
        state.openId = openid
      }
      return state.openId
    }
  }
})
export default store



// WEBPACK FOOTER //
// ./src/store/store.js